import { RestModel } from './core/RestModel'

export class CategoryModel extends RestModel {
  constructor(data = {}) {
    super(data, {
      name: 'category',
      endpoint: '/categories',
      schema: {
        id: Number,
        name: String,
        slug: String,
        icon: String,
        order: Number,
        isActive: Boolean,
        markup: Number,
        discount: Number,
        discountStart: String,
        discountEnd: String,
        parentId: Number,
        // Shop filters [{ specDefinitionId, type }]; null uses the parent's.
        filters: Array,
        createdAt: String,
        updatedAt: String,
      },
    })
  }
}

export default CategoryModel
